import { useState, useEffect } from 'react';
import api from '../services/api';

export function useSeance(seanceId) {
  const [seance, setSeance] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch seance data from API
  useEffect(() => {
    const fetchSeance = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await api.seance.getSeanceById(seanceId);
        
        // Extract seance data from the nested response structure
        const seanceData = response.data?.seance || response;
        
        // Use API structure directly, only ensure blocks have ids for React keys
        const seanceWithIds = {
          ...seanceData,
          sequences: (seanceData.sequences || []).map(sequence => ({
            ...sequence,
            blocs: (sequence.blocs || []).map(bloc => ({
              ...bloc,
              id: bloc.id || `bloc_${bloc.bloc_index ?? Date.now()}` // Ensure each block has an id for React
            }))
          }))
        };
        
        setSeance(seanceWithIds);
      } catch (err) {
        console.error('Error fetching seance:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (seanceId) {
      fetchSeance();
    }
  }, [seanceId]);

  const updateSeance = async () => {
    // Refetch the seance data
    try {
      const response = await api.seance.getSeanceById(seanceId);
      console.log('Fetched seance data:', response);
      
      // Extract seance data from the nested response structure
      const seanceData = response.data?.seance || response;
      console.log('Extracted seance data:', seanceData);
      
      // Use API structure directly, only ensure blocks have ids for React keys
      const seanceWithIds = {
        ...seanceData,
        sequences: (seanceData.sequences || []).map(sequence => ({
          ...sequence,
          blocs: (sequence.blocs || []).map(bloc => ({
            ...bloc,
            id: bloc.id || `bloc_${bloc.bloc_index ?? Date.now()}` // Ensure each block has an id for React
          }))
        }))
      };
      
      console.log('Seance data with ids:', seanceWithIds);
      setSeance(seanceWithIds);
    } catch (err) {
      console.error('Error updating seance:', err);
      setError(err.message);
    }
  };

  return { seance, isLoading, error, updateSeance };
}
